export default "__VITE_ASSET__CByi6Ho8__"